/* eslint-disable no-use-before-define */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl } from '@mui/material';
import PropTypes from 'prop-types';

import { authService, companyService } from '../../../../../services/napoleon';
import useToastActions from '../../../../../redux/actions/useToastActions';
import { REGISTER_STEPS } from '../../../../../constants/registerSteps';
import { ButtonComponent } from '../../../../../components';
import { Input } from '../../../../../components/Form';
import styles, { FormContainer, Footer } from '../../styles';
import useFormStep from './useFormStep';
import StepsHeadline from './StepsHeadline';
import { handleAccessFactory } from '../../../helpers';

const formStep = REGISTER_STEPS.DISCOUNT;

export default function DiscountCoupon({ handleBack }) {
  const dispatch = useDispatch();
  const { companyId, steps, authByGoogle } = useSelector((state) => state.registerStepReducer);
  const currentStep = useSelector((state) => state.registerStepReducer.currentStep);
  const signInInfo = steps[REGISTER_STEPS.SIGN_IN_INFO];
  const { error } = useToastActions();

  const access = handleAccessFactory(dispatch, authService, currentStep);

  async function handleLogin() {
    const { authGoogle } = authByGoogle;
    const payload = { email: signInInfo.email, password: signInInfo.password, authGoogle };

    const result = await access(payload);

    if (!result.success) {
      error('Erro ao tentar logar usuário. Tente novamente mais tarde.');
    }
  }

  async function updateCompanyDiscountCoupon() {
    try {
      await companyService.update({ discountCoupon: form.discountCoupon, id: companyId });
      await handleLogin();
    } catch (err) {
      error('Erro ao tentar atualizar dados. Tente novamente mais tarde.');
    }
  }

  const validateField = () => '';

  const {
    form,
    formErrors,
    isLoading,
    inputRef,
    handleChange,
    handleSubmit,
    updateRedux,
    isStepValid,
  } = useFormStep(formStep, validateField, updateCompanyDiscountCoupon);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <FormContainer onSubmit={handleSubmit}>
      <StepsHeadline />

      <FormControl sx={styles.textField} variant="standard">
        <Input
          placeholder="Cupom de desconto"
          value={form.discountCoupon}
          ref={inputRef}
          onChange={handleChange}
          type="text"
          name="discountCoupon"
          inputProps={{ maxLength: 200 }}
          error={!!formErrors.discountCoupon}
          helperText={formErrors.discountCoupon}
          disabled={isLoading}
        />
      </FormControl>

      <Footer style={styles.registerStepsFooter}>
        <ButtonComponent
          size="small"
          variant="outlined"
          disabled={isLoading}
          onClick={() => {
            updateRedux();
            handleBack();
          }}
        >
          Voltar
        </ButtonComponent>

        <ButtonComponent
          type={isLoading ? 'button' : 'submit'}
          size="small"
          disabled={!isStepValid() || isLoading}
          loading={isLoading}
        >
          Concluir
        </ButtonComponent>
      </Footer>
    </FormContainer>
  );
}

DiscountCoupon.propTypes = {
  handleBack: PropTypes.func.isRequired,
};
